"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
// типов для библиотеки нет, надо просто свое сделать
// @ts-ignore
var react_scroll_up_1 = __importDefault(require("react-scroll-up"));
var Breadcrumbs_1 = __importDefault(require("../../common/Breadcrumbs"));
var SeoText_1 = __importDefault(require("./SeoText"));
var TagCloud_1 = __importDefault(require("./TagCloud"));
var Sidebar_1 = __importDefault(require("./Sidebar"));
var Filters_1 = __importDefault(require("./Filters"));
var Products_1 = __importDefault(require("./Products"));
var Pagination_1 = __importDefault(require("./Pagination"));
var Advantages_1 = __importDefault(require("./Advantages"));
var NoFindProducts_1 = __importDefault(require("./NoFindProducts"));
var SeoHeader_1 = __importDefault(require("./SeoHeader"));
var Error_1 = __importDefault(require("../../common/Error"));
var FAQ_1 = __importDefault(require("./FAQ"));
var Categories_1 = __importDefault(require("./Filters/Categories"));
var SortBy_1 = __importDefault(require("./Filters/SortBy"));
var DataTags_1 = __importDefault(require("./DataTags"));
var selectors_1 = require("../selectors");
// import SeoTabsContainer from './SeoTabsContainer'
require("../store-styles.css");
var selectors_2 = require("../../common/selectors");
var atoms_1 = require("../../styles/atoms");
var styled_components_1 = __importDefault(require("styled-components"));
var quards_1 = require("../../../utils/quards");
function Root() {
    var _a;
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_2.isCustomStoreSelector);
    var breadcrumbs = (0, react_redux_1.useSelector)(selectors_1.breadcrumbsSelector);
    var ownDesignAllowed = (0, react_redux_1.useSelector)(selectors_1.ownDesignAllowedSelector);
    var isFavorites = (0, react_redux_1.useSelector)(selectors_1.isFavoritesSelector);
    var isMobile = (0, react_redux_1.useSelector)(selectors_2.isMobileSelector);
    var description = (0, quards_1.guardString)((0, selectors_1.useSeoTypeSelector)('regularText'));
    var _b = (0, react_1.useState)(false), hasError = _b[0], setHasError = _b[1];
    (0, react_1.useEffect)(function () {
        var alertCloseBtn = document.querySelector('.discard');
        if (!alertCloseBtn)
            return;
        alertCloseBtn.addEventListener('click', function () {
            var alert = alertCloseBtn.closest('.global-error-message.alert');
            if (!alert)
                return;
            alert.style.display = 'none';
        });
    }, []);
    return !hasError ? (react_1.default.createElement("div", { className: "resp-container content" },
        react_1.default.createElement(DataTags_1.default, null),
        react_1.default.createElement(Breadcrumbs_1.default, { items: breadcrumbs }),
        !isCustomStore && react_1.default.createElement(SeoHeader_1.default, null),
        !isFavorites && react_1.default.createElement(Filters_1.default, null),
        react_1.default.createElement(MainContainer, null,
            !isFavorites && !isMobile && (react_1.default.createElement(DesktopSidebarContainer, null,
                react_1.default.createElement(Sidebar_1.default, null))),
            react_1.default.createElement(ProductsContainer, null,
                !isCustomStore && !isFavorites && (react_1.default.createElement(FiltersContainer, null,
                    react_1.default.createElement(Categories_1.default, null),
                    react_1.default.createElement(SortBy_1.default, null))),
                !isFavorites && react_1.default.createElement(TagCloud_1.default, null),
                react_1.default.createElement("div", { className: "row content__products" },
                    react_1.default.createElement(Products_1.default, null)),
                react_1.default.createElement("div", { className: "content__pagination" },
                    react_1.default.createElement(Pagination_1.default, null)),
                react_1.default.createElement(atoms_1.Div, { visible: !isCustomStore, className: "content__tabs" }),
                react_1.default.createElement(atoms_1.Div, { visible: !isCustomStore || ownDesignAllowed, className: "content__no-find-products" },
                    react_1.default.createElement(NoFindProducts_1.default, null)),
                react_1.default.createElement("div", { className: "content__description" },
                    react_1.default.createElement(Description, { dangerouslySetInnerHTML: { __html: description } })),
                react_1.default.createElement("div", { className: "content__advantages" },
                    react_1.default.createElement(Advantages_1.default, null)),
                react_1.default.createElement("div", { className: "content__faq" },
                    react_1.default.createElement(FAQ_1.default, null)),
                react_1.default.createElement(atoms_1.Div, { visible: isMobile, className: "content__after-menu-text" },
                    react_1.default.createElement(SeoText_1.default, { type: "afterMenuText", className: "after-menu-text" })),
                react_1.default.createElement(SeoText_1.default, { type: "beforeFooterText", className: "before-footer-text text-center" }),
                react_1.default.createElement(react_scroll_up_1.default, { showUnder: 160, style: (_a = {
                            position: 'fixed',
                            bottom: isMobile ? 20 : 35
                        },
                        _a[isMobile ? 'left' : 'right'] = 20,
                        _a.cursor = 'pointer',
                        _a.transitionDuration = '0.2s',
                        _a.transitionTimingFunction = 'linear',
                        _a.transitionDelay = '0s',
                        _a.width = 65,
                        _a.height = 65,
                        _a.backgroundColor = '#333',
                        _a.borderRadius = 37,
                        _a.color = '#fff',
                        _a.fontSize = 40,
                        _a.lineHeight = '60px',
                        _a.textAlign = 'center',
                        _a.zIndex = 1,
                        _a) },
                    react_1.default.createElement("i", { className: "fas fa-chevron-up" })))))) : (react_1.default.createElement("div", { className: "resp-container" },
        react_1.default.createElement(Error_1.default, null)));
}
exports.default = Root;
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding-bottom: 40px;\n"], ["\n  display: flex;\n  padding-bottom: 40px;\n"])));
var ProductsContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var FiltersContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media (max-width: 940px), (hover: none) {\n    display: none;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media (max-width: 940px), (hover: none) {\n    display: none;\n  }\n"])));
var DesktopSidebarContainer = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 160px;\n  margin-right: 70px;\n  flex-shrink: 0;\n\n  @media (max-width: 940px), (hover: none) {\n    display: none;\n  }\n"], ["\n  width: 160px;\n  margin-right: 70px;\n  flex-shrink: 0;\n\n  @media (max-width: 940px), (hover: none) {\n    display: none;\n  }\n"])));
var Description = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.5;\n  margin-top: 8px;\n  margin-bottom: 24px;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.5;\n  margin-top: 8px;\n  margin-bottom: 24px;\n"])), function (p) { return p.theme.fontSize.small; }, function (p) { return p.theme.colors.grayDark; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
